export default "__VITE_ASSET__BrzHI0Fy__"